// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3542":"010f319f","9217":"09501cad"}[chunkId] + ".chunk.css";
};